import { render, staticRenderFns } from "./EventPopularServices.vue?vue&type=template&id=5826d68b"
import script from "./EventPopularServices.vue?vue&type=script&lang=js"
export * from "./EventPopularServices.vue?vue&type=script&lang=js"
import style0 from "./EventPopularServices.vue?vue&type=style&index=0&id=5826d68b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports